import { RouteConfig } from 'vue-router'

const Page404 = () =>
  import(/* webpackChunkName: "page404" */ '@/views/Page404.vue')
const Page500 = () =>
  import(/* webpackChunkName: "page500" */ '@/views/Page500.vue')
const Login = () =>
  import(/* webpackChunkName: "login" */ '@/views/Login.vue')
const MainContainer = () =>
  import(/* webpackChunkName: "maincontainer" */ '@/containers/MainContainer.vue')
const Home = () => import(/* webpackChunkName: "home" */ '@/views/Home.vue')
const Search = () =>
  import(/* webpackChunkName: "search" */ '@/views/Search.vue')
const Repository = () =>
  import(/* webpackChunkName: "repository" */ '@/views/Repository.vue')
const Project = () =>
  import(/* webpackChunkName: "project" */ '@/views/Project.vue')
const Product = () =>
  import(/* webpackChunkName: "product" */ '@/views/Product.vue')
const WorkModule = () => import(/* webpackChunkName: "workModule" */ '@/views/WorkModule.vue')
const Preview = () =>
  import(/* webpackChunkName: "preview" */ '@/views/Preview.vue')
const Assets = () =>
  import(/* webpackChunkName: "assets" */ '@/views/Assets.vue')

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: '/home',
    name: 'LDX',
    meta: {
      label: 'LDX',
      title: ''
    },
    component: MainContainer,
    children: [
      {
        path: 'home',
        name: 'Home',
        meta: {
          label: '::i18n_homeLabel::',
          requiresAuth: true
        },
        component: Home
      },
      {
        path: 'search',
        name: 'Search',
        meta: {
          label: '::i18n_searchLabel::',
          requiresAuth: true
        },
        component: Search
      },
      {
        path: 'projects',
        name: 'Projects',
        meta: {
          label: '::i18n_projectsLabel::',
          requiresAuth: true
        },
        component: Repository
      },
      {
        path: 'projects/:projectId',
        name: 'Project',
        meta: {
          label: '::projectName::',
          requiresAuth: true
        },
        props: true,
        component: Project,
        children: [
          {
            path: 'course/:productId',
            name: 'Product',
            meta: {
              label: '::productTitle::',
              requiresAuth: true,
              toHistory: true
            },
            props: true,
            component: Product,
            children: [
              {
                path: 'work-modules/:workModuleCode',
                name: 'WorkModule',
                meta: {
                  label: '::workModuleTitle::',
                  requiresAuth: true,
                  toHistory: true
                },
                props: true,
                component: WorkModule
              },
              {
                path: 'work-modules/:workModuleCode/preview',
                name: 'Preview',
                meta: {
                  label: '::workModuleTitle::',
                  requiresAuth: true
                },
                component: Preview
              },
              {
                path: 'work-modules/:workModuleCode/assets',
                name: 'Assets',
                meta: {
                  label: '::workModuleTitle::',
                  requiresAuth: true
                },
                component: Assets
              }
            ]
          }
        ]
      },
      {
        path: '/about',
        name: 'About',
        component: () =>
          import('@/views/About.vue'),
        meta: {
          label: '::i18n_helpLabel::'
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      label: 'Login',
      title: 'Login'
    }
  },
  {
    path: '/course/:productId/unit/:unitId/preview',
    name: 'FullWindowPreview',
    meta: {
      label: 'Visualizar Producto',
      requiresAuth: true,
      isAdmin: true
    },
    component: Preview
  },
  {
    path: '/500',
    name: 'Page500',
    component: Page500
  },
  {
    path: '/:catchAll(.*)',
    name: 'Page404',
    component: Page404
  }
]

export default routes
